import { useTranslation } from "react-i18next";

import w1 from '../../img/w1.svg';
import w2 from '../../img/w2.svg';
import w3 from '../../img/w3.svg';
import w4 from '../../img/w4.svg';

function WhyChoose() {
  const { t } = useTranslation();

  return (
    <>
      <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px]">
        <p className="host-grotesk leading-[1.2] xl:text-[40px] text-[#2A323F] text-[28px]">{t('home.47')}</p>
        <div className="grid grid-cols-1 xl:grid-cols-2 mt-[40px] xl:mt-[60px]">
          <div className="flex gap-[20px] xl:gap-[60px] items-start border-b xl:border-r border-[#CECABE] pb-[20px] xl:pb-[52px]">
            <img src={w1} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]" />
            <div className="mt-[10px]">
              <p className="host-grotesk leading-[1.2] text-[16px] xl:text-[20px]">{t('home.48')}</p>
              <p className="text-[#000000B2] xl:max-w-[429px] PtRoot text-[12px] xl:text-[14px] mt-[12px]">{t('home.49')}</p>
            </div>
          </div>
          <div className="flex gap-[20px] xl:gap-[60px] items-start justify-end border-b border-[#CECABE] pb-[20px] xl:pb-[52px] pt-[20px] xl:pt-0">
            <img src={w2} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]" />
            <div className="mt-[10px]">
              <p className="host-grotesk leading-[1.2] text-[16px] xl:text-[20px]">{t('home.50')}</p>
              <p className="text-[#000000B2] xl:max-w-[429px] PtRoot text-[12px] xl:text-[14px] mt-[12px]">{t('home.51')}</p>
            </div>
          </div>
          <div className="flex gap-[20px] xl:gap-[60px] items-start pt-[20px] xl:pt-[52px] xl:border-r border-b xl:border-b-0 pb-[20px] xl:pb-0 border-[#CECABE]">
            <img src={w3} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]" />
            <div className="mt-[10px]">
              <p className="host-grotesk leading-[1.2] text-[16px] xl:text-[20px]">{t('home.52')}</p>
              <p className="text-[#000000B2] xl:max-w-[429px] PtRoot text-[12px] xl:text-[14px] mt-[12px]">{t('home.53')}</p>
            </div>
          </div>
          <div className="flex gap-[20px] xl:gap-[60px] items-start pt-[20px] xl:pt-[52px] justify-end border-b xl:border-b-0 pb-[20px] xl:pb-0 border-[#CECABE]">
            <img src={w4} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]" />
            <div className="mt-[10px]">
              <p className="host-grotesk leading-[1.2] text-[16px] xl:text-[20px]">{t('home.54')}</p>
              <p className="text-[#000000B2] xl:max-w-[429px] PtRoot text-[12px] xl:text-[14px] mt-[12px]">{t('home.55')}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WhyChoose;
